import React, { useState, useCallback, useEffect } from "react";
import { Container, Content, Title, Field, Input, Label } from "./styles";

import {
  Modal,
  Button,
  Checkbox,
  Icon,
  Dropdown,
  Form,
  TextArea,
  Tab,
} from "semantic-ui-react";

import { producaov2 as api } from "../../../services/apis";

import swal from "sweetalert";
import { RenderIf } from "../../RenderIf";

export function AlunoSearchInput({
  handleChange,
  hideLabel = false,
  clearableOnSelect = false,
  ...props
}) {
  const [aluno, setAluno] = useState(null);
  const [alunosOptions, setAlunosOptions] = useState([]);
  const [alunoSearch, setAlunoSearch] = useState("");

  const handleAlunoChange = useCallback(
    (e, { options, value }) => {
      const text = options.find(option => option.value === value).text;

      setAluno(value);
      handleChange(value);
      setAlunoSearch(text);
    },
    [props]
  );

  const handleAlunoSearchChange = useCallback(e => {
    const search = e.target.value;

    if (search) {
      setAlunoSearch(search);

      const cleanSearch = search.trim();

      api.get(`alunos?search=${cleanSearch}&limit=15`).then(res => {
        if (res.data.length > 0) {
          const options = res.data.map((pessoa, index) => ({
            key: index,
            text: `(${pessoa.email}) [ID: ${pessoa.id}]`,
            value: {
              id: pessoa.id,
              email: pessoa.email,
            },
          }));
          setAlunosOptions(options);
          return;
        }
        setAlunosOptions([]);
      });
    }
  });

  const initialLoad = useCallback(async () => {
    try {
      if (aluno) {
        return;
      }

      const id = props.initialValue;

      if (id) {
        const { aluno: alunoResponse } = (await api.get(`alunos/${id}`)).data;

        const newAlunosOptions = [
          {
            key: 0,
            text: `(${alunoResponse.email}) [ID: ${alunoResponse.id}]`,
            value: alunoResponse.id,
          },
        ];

        setAlunosOptions(newAlunosOptions);
        setAluno(id);
      }
    } catch (err) {
      console.error(err);
      return;
    }
  }, [props, aluno]);

  useEffect(() => {
    initialLoad();
  }, [props]);

  return (
    <Container>
      <div>
        <RenderIf isTrue={!hideLabel}>
          <Label>Selecione o aluno</Label>
        </RenderIf>
        <Dropdown
          placeholder="Busque pelo ID, Nome ou E-mail do aluno"
          fluid
          search
          selection
          options={alunosOptions}
          onChange={handleAlunoChange}
          // searchQuery={alunoSearch}
          onSearchChange={handleAlunoSearchChange}
          value={aluno}
        />
      </div>
    </Container>
  );
}
